type LogLevel = 'info' | 'warn' | 'error'

interface LogEntry {
  timestamp: number
  level: LogLevel
  message: string
  userId?: string
  action?: string
  data?: any
}

class StoreLogger {
  private static instance: StoreLogger
  private logs: LogEntry[] = []
  private readonly MAX_LOGS = 1000

  private constructor() {}

  static getInstance(): StoreLogger {
    if (!StoreLogger.instance) {
      StoreLogger.instance = new StoreLogger()
    }
    return StoreLogger.instance
  }

  private addLog(level: LogLevel, message: string, userId?: string, action?: string, data?: any) {
    const logEntry: LogEntry = {
      timestamp: Date.now(),
      level,
      message,
      userId,
      action,
      data
    }

    this.logs.unshift(logEntry)
    
    // 保持日志数量在限制内
    if (this.logs.length > this.MAX_LOGS) {
      this.logs = this.logs.slice(0, this.MAX_LOGS)
    }

    // 在开发环境下打印日志
    if (process.env.NODE_ENV === 'development') {
      console[level](
        `[${new Date(logEntry.timestamp).toISOString()}] ${level.toUpperCase()}: ${message}`,
        { userId, action, data }
      )
    }
  }

  info(message: string, userId?: string, action?: string, data?: any) {
    this.addLog('info', message, userId, action, data)
  }

  warn(message: string, userId?: string, action?: string, data?: any) {
    this.addLog('warn', message, userId, action, data)
  }

  error(message: string, userId?: string, action?: string, data?: any) {
    this.addLog('error', message, userId, action, data)
  }

  getLogs(level?: LogLevel, userId?: string): LogEntry[] {
    return this.logs.filter(log => 
      (!level || log.level === level) &&
      (!userId || log.userId === userId)
    )
  }

  clearLogs() {
    this.logs = []
  }
}

export const logger = StoreLogger.getInstance() 